import React from 'react';

const IconBase = ({ children, size = 18, className = '' }) => (
  <span
    className={`inline-flex items-center justify-center ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      {children}
    </svg>
  </span>
);

const WhatsApp = ({ size, className }) => (
  <IconBase size={size} className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </IconBase>
);

const Messenger = ({ size, className }) => (
  <IconBase size={size} className={className}>
    <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.3 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111C24 4.974 18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8.1l3.131 3.26L19.752 8.1l-6.561 6.863z" />
  </IconBase>
);

const Instagram = ({ size, className }) => (
  <IconBase size={size} className={className}>
    <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5.3A4.7 4.7 0 1016.7 12 4.71 4.71 0 0012 7.3zm0 7.7A3 3 0 1115 12a3 3 0 01-3 3zm5.5-8.4a1.1 1.1 0 11-1.1-1.1 1.1 1.1 0 011.1 1.1z" />
  </IconBase>
);

const Email = ({ size, className }) => (
  <IconBase size={size} className={className}>
    <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </IconBase>
);

const Web = ({ size, className }) => (
  <IconBase size={size} className={className}>
    <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.94 9H16.9a15.7 15.7 0 00-1.35-6.05A8.02 8.02 0 0119.94 11zM12 4c1.23 0 2.9 2.5 3.54 7H8.46C9.1 6.5 10.77 4 12 4zM4.06 13H7.1a15.7 15.7 0 001.35 6.05A8.02 8.02 0 014.06 13zM7.1 11H4.06a8.02 8.02 0 014.39-6.05A15.7 15.7 0 007.1 11zm1.36 2h7.08c-.64 4.5-2.31 7-3.54 7s-2.9-2.5-3.54-7zm8.44 6.05A15.7 15.7 0 0016.9 13h3.04a8.02 8.02 0 01-4.39 6.05z" />
  </IconBase>
);

const normalize = (channel) => String(channel || '').toLowerCase();

export default function ChannelIcon({ channel, size = 18, className = '' }) {
  const c = normalize(channel);
  if (c.includes('whatsapp')) return <WhatsApp size={size} className={className} />;
  if (c.includes('messenger') || c.includes('facebook')) return <Messenger size={size} className={className} />;
  if (c.includes('instagram')) return <Instagram size={size} className={className} />;
  if (c.includes('email')) return <Email size={size} className={className} />;
  return <Web size={size} className={className} />;
}
